/* EuroSpeed search-results filter strip (2026-09-23).

   Jeff: "if I search APR products, the carousel at the top could be like almost the filter --
   exhaust, intake, sway bar, suspension", and then: "the images should be legit examples of that
   actual brand. So if I searched APR, the exhaust thumbnail would be an APR exhaust... the
   carousel is based off the actual content of what is on the collection and product screen."

   So the art is NOT a static category library. Each card takes its photo from a real product in
   the current result set for that category, which makes it brand-accurate for free: APR search =
   APR parts, Forge search = Forge parts. window.ES_CAT_ART is only a fallback for a category
   whose products have no usable image.

   Each card REFINES the query (/search?q=APR tag:"cat-exhaust") rather than ticking the Category
   checkbox -- the checkbox unions that category across the whole catalogue and loses the search
   term (verified: q=APR 310 results, refined link 57, checkbox route 126). A link also gives the
   refined view a shareable URL.

   Carousel engine + CSS are the site-wide ones (assets/es-carousel.js, assets/es-ui.css). */
(function () {
  var MIN_CARDS = 3;          // fewer than this and a strip is just noise
  var MIN_PRODUCTS = 2;       // a category with a single hit is not worth a card
  var MIN_IMG = 300;          // Jeff: don't show it if it isn't clean -- skip small/placeholder art

  /* Fallback labels for every governed cat-* bucket (category-reference.md) so a category missing from
     window.ES_CAT_ART (no baked art) still gets a card using a real product photo from the grid. */
  var CAT_LABELS = {"cat-bov-diverter": "Blow Off & Diverter Valves", "cat-boost-sensors": "Boost Taps & Sensors", "cat-braces-cages": "Chassis Braces & Cages", "cat-brakes": "Brakes, Pads & Rotors", "cat-carbon-fiber": "Carbon Fiber", "cat-catch-cans-pcv": "Catch Cans & PCV", "cat-clutch-flywheels": "Clutch Kits & Flywheels", "cat-coilovers-springs": "Coilovers & Springs", "cat-control-arms": "Control Arms & Bushings", "cat-ecu-tuning": "ECUs & Tuning", "cat-engine-internals": "Engine Internals", "cat-engine-mounts": "Engine & Drivetrain Mounts", "cat-exhaust": "Exhausts & Downpipes", "cat-exterior-accessories": "Exterior Accessories", "cat-fueling": "Fuel Systems", "cat-gauges": "Gauges & Pods", "cat-heat-management": "Heat Management", "cat-ignition": "Ignition & Spark Plugs", "cat-intakes": "Intakes & Filters", "cat-intercoolers": "Intercoolers & Piping", "cat-interior-accessories": "Interior Accessories", "cat-lighting": "Lighting", "cat-maintenance": "Maintenance & Service", "cat-oil-pans": "Oil Pans & Shields", "cat-oils-fluids": "Oils & Fluids", "cat-pulleys": "Pulleys", "cat-radiators-cooling": "Radiators & Cooling", "cat-shocks-struts": "Shocks & Struts", "cat-skirts-splitters-spoilers": "Skirts, Splitters & Spoilers", "cat-sway-bars": "Sway Bars & End Links", "cat-throttle-bodies": "Throttle Bodies & Manifolds", "cat-tools-hardware": "Tools & Hardware", "cat-transmission-shifters": "Transmission & Shifters", "cat-turbos-superchargers": "Turbos & Superchargers", "cat-water-meth-nitrous": "Water/Meth & Nitrous", "cat-wheel-spacers": "Wheel Spacers", "cat-wheels": "Wheels", "cat-decals-stickers": "Decals & Badges", "cat-apparel-merch": "Apparel & Merch", "cat-air-suspension": "Air Suspension"};
  function catLabel(t, FALLBACK) { return (FALLBACK[t] && FALLBACK[t].label) || CAT_LABELS[t] || null; }

  function params() { return new URLSearchParams(window.location.search); }

  function baseQuery() {
    var q = params().get('q') || '';
    return q.replace(/\s*tag:"cat-[a-z0-9-]+"/gi, '').trim();
  }

  function activeCat() {
    var m = (params().get('q') || '').match(/tag:"(cat-[a-z0-9-]+)"/i);
    return m ? m[1].toLowerCase() : null;
  }

  function searchUrl(q) {
    var p = params();
    p.set('q', q);
    p.set('type', 'product');
    return window.location.pathname + '?' + p.toString();
  }

  function usableImage(item) {
    var img = item.querySelector('.product-thumb img');
    if (!img) return null;
    var src = img.getAttribute('src') || '';
    if (!src || /no-image|placeholder|\.svg(\?|$)/i.test(src)) return null;
    var w = parseInt(img.getAttribute('width') || '0', 10);
    var h = parseInt(img.getAttribute('height') || '0', 10);
    if (w && w < MIN_IMG) return null;
    if (h && h < MIN_IMG) return null;
    // heavily non-square art (banners, dyno sheets) crops badly in a card
    if (w && h && (w / h > 2.2 || h / w > 2.2)) return null;
    return src.indexOf('//') === 0 ? window.location.protocol + src : src;
  }

  /* One pass over the rendered results: per category, how many products and the best photo among
     them. "Best" is simply the first usable one -- results are relevance-ordered, so the leading
     product is the most representative thing we can show for that category. */
  function scan() {
    var out = {};
    document.querySelectorAll('.product-item[data-tags]').forEach(function (el) {
      var tags = (el.getAttribute('data-tags') || '').split(',');
      var img = null, looked = false;
      tags.forEach(function (t) {
        t = t.trim();
        if (t.indexOf('cat-') !== 0) return;
        if (!out[t]) out[t] = { n: 0, img: null };
        out[t].n++;
        if (!out[t].img) {
          if (!looked) { img = usableImage(el); looked = true; }
          if (img) out[t].img = img;
        }
      });
    });
    return out;
  }

  function imgAttrs(img, label) {
    var isCdn = /cdn\.shopify\.com|\/cdn\/shop\//.test(img);
    var base = img.replace(/([?&])width=\d+/, '$1width=600');
    var q = base.indexOf('?') > -1 ? '&' : '?';
    var src = isCdn && !/width=/.test(base) ? base + q + 'width=600' : base;
    return 'src="' + src + '" width="600" height="400" alt="' + label + '" loading="lazy" decoding="async"';
  }

  function build() {
    var host = document.getElementById('es-search-strip');
    if (!host || host.dataset.built) return;
    var FALLBACK = window.ES_CAT_ART || {};
    var base = baseQuery();
    var active = activeCat();
    if (!base) { host.style.display = 'none'; return; }

    var found = scan();
    var art = {};     // cat -> {label, img}
    Object.keys(found).forEach(function (t) {
      var label = catLabel(t, FALLBACK);
      if (!label) return;                       // unknown bucket -- no label to show
      var img = found[t].img || (FALLBACK[t] && FALLBACK[t].img);
      if (!img) return;                         // nothing clean to show -- skip the card entirely
      art[t] = { label: label, img: img, n: found[t].n };
    });

    function pickRows(minProducts) {
      return Object.keys(art)
        .filter(function (t) { return art[t].n >= minProducts; })
        .sort(function (a, b) { return art[b].n - art[a].n; })
        .slice(0, 14);
    }
    var rows = pickRows(MIN_PRODUCTS);
    // Thin vehicle result sets: never hide the strip (STANDING-DECISIONS 28), fall back to
    // single-product categories (each refinement still returns at least that product).
    if (rows.length < MIN_CARDS && /tag:/.test(base)) rows = pickRows(1);

    /* Once a refinement is on, the page holds only that category, so recomputing from the DOM
       would leave a single card and no way back. Remember the unrefined set (ids AND their
       brand-accurate art) for the base query and reuse it. */
    var KEY = 'es-strip:' + base;
    if (!active) {
      if (rows.length >= MIN_CARDS) {
        try { sessionStorage.setItem(KEY, JSON.stringify({ rows: rows, art: art })); } catch (_) {}
      }
    } else {
      try {
        var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (saved && saved.rows && saved.rows.length) { rows = saved.rows; art = saved.art; }
      } catch (_) {}
    }

    if (active && art[active] && rows.indexOf(active) === -1) rows.unshift(active);
    if (rows.length < ((active || /tag:/.test(base)) ? 1 : MIN_CARDS)) { host.style.display = 'none'; return; }

    host.dataset.built = '1';
    var cards = rows.map(function (t) {
      var on = (t === active);
      var href = searchUrl(on ? base : base + ' tag:"' + t + '"');
      return '<a class="es-crs-card es-strip-card' + (on ? ' is-active' : '') + '" href="' + href + '">'
        + '<span class="es-crs-imgwrap"><img ' + imgAttrs(art[t].img, art[t].label) + '>'
        + '<span class="es-crs-scrim"></span><span class="es-crs-txt">'
        + '<span class="es-crs-label">' + art[t].label + '</span>'
        + '<span class="es-crs-cta">' + (on ? 'Clear filter' : 'Show these') + '</span>'
        + '</span></span></a>';
    }).join('');

    host.innerHTML =
      '<div class="es-strip-inner">'
      + '<div class="es-strip-head"><span class="es-strip-kicker">'
      + (active ? 'Showing ' + art[active].label + ' — tap again to clear' : 'Narrow it down')
      + '</span></div>'
      + '<div class="es-crs" data-es-carousel data-drift="0.33">'
      + '<div class="es-crs-arrow es-crs-prev" data-dir="-1">‹</div><div class="es-crs-track">'
      + cards
      + '</div><div class="es-crs-arrow es-crs-next" data-dir="1">›</div></div>'
      + '</div>';

    if (window.esCarouselInit) window.esCarouselInit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
